import { ArrayField, DataTable, type DataTableProps } from "react-admin";
import { ProductField } from "../../components";
import { orderDetailToProduct, type OrderDetail, type OrderItem } from "../../models";

export const OrderDetailGrid = (props: DataTableProps<OrderDetail>): JSX.Element => {
    return (
        <ArrayField<OrderItem> source="details">
            <DataTable<OrderDetail> rowClick={false} {...props}>
                <DataTable.Col<OrderDetail> source="name">
                    <ProductField<OrderDetail> source="id" map={orderDetailToProduct} />
                </DataTable.Col>
                <DataTable.NumberCol<OrderDetail> source="quantity" />
            </DataTable>
        </ArrayField>
    );
};
